import React from "react";

import { cn } from "utils/cn";

const Table = ({ children, className }) => {
  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
      <table className={cn("w-full text-left text-sm text-gray-500 rtl:text-right ", className)}>{children}</table>
    </div>
  );
};

const TableHeader = ({ children, className }) => {
  return <thead className={cn("bg-gray-50 text-xs uppercase text-gray-700", className)}>{children}</thead>;
};

const TableHeaderCell = ({ children, className }) => {
  return (
    <th scope="col" className={cn("px-6 py-3", className)}>
      {children}
    </th>
  );
};

const TableBody = ({ children, noDataMessage = "No Data", emptyColSpan = 1 }) => {
  const hasChildren = children && React.Children.count(children) > 0;

  if (!hasChildren) {
    return (
      <tbody>
        <TableRow>
          <TableCell className="w-full text-center" colspan={emptyColSpan}>
            {noDataMessage}
          </TableCell>
        </TableRow>
      </tbody>
    );
  }
  return <tbody>{children}</tbody>;
};

const TableRow = ({ children, className }) => {
  return <tr className={cn("border-b odd:bg-white even:bg-gray-50", className)}>{children}</tr>;
};

const TableCell = ({ children, className, colspan }) => {
  return (
    <td colSpan={colspan} className={cn("whitespace-nowrap px-6 py-4", className)}>
      {children}
    </td>
  );
};

export { Table, TableHeader, TableHeaderCell, TableBody, TableRow, TableCell };
